import styled from "styled-components";
import theme from "../../../styles/theme";

export const ConsultLabel = styled.span<{ qty: number }>`
  font-family: sans-serif;
  font-weight: 700;
  color: white;
  font-size: ${theme.fontSize.mm};
  @media ${theme.devices.tablet} {
    font-size: ${(props) => (props.qty < 100 ? "16px" : "15px")};
  }
`;

export const HeaderCredits = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  color: white;
  margin-bottom: 30px;
  h1 {
    font-family: sans-serif;
    font-weight: 700;
    font-size: ${theme.fontSize.lg};
    margin-bottom: 5px;
  }

  h2 {
    font-family: sans-serif;
    font-weight: 600;
    font-size: ${theme.fontSize.md2};
    margin-bottom: 5px;
  }
`;

export const ConsultLabelWarning = styled.a`
  font-family: sans-serif;
  cursor: pointer;
  font-weight: 700;
  color: red;
  font-size: ${theme.fontSize.xsm};
`;
export const Container = styled.div`
  border-style: solid;
  border-width: 1px;
  border-color: ${theme.colors.palete.gold};
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80%;
  margin-inline: 3vw;
  .main-label {
    font-family: sans-serif;
    font-weight: 800;
    color: white;
    font-size: ${theme.fontSize.lg};
    align-self: center;
    margin-top: 10vh;
    @media ${theme.devices.tablet} {
      margin-top: 5vh;
      font-size: ${theme.fontSize.md};
      text-align: -webkit-center;
    }
  }
  @media ${theme.devices.tablet} {
    height: max-content;
    padding-bottom: 5vh;
    margin-bottom: 5vh;
    margin-inline: 5vw;
  }
`;

export const MobileContainer = styled.div`
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 2vh;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  place-content: center;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    margin-top: 0vh;
    align-items: center;
    row-gap: 0vh;
  }
`;
export const CardsImg = styled.img`
  height: 20vh;
`;
export const AccountSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 35vw;
  min-width: 35vw;
  width: 100%;
  .label {
    color: white;
    width: 100%;
    font-size: ${theme.fontSize.mm};
    text-align-last: right;
    margin-right: 1vw;
    @media ${theme.devices.tablet} {
      text-align-last: auto;
      margin-left: 5vw;
      width: 70vw;
    }
  }
  @media ${theme.devices.tablet} {
    max-width: 95vw;
    min-width: 95vw;
    column-gap: 0px;
    margin-bottom: 2vh;
  }
`;
